import React, { useState, useEffect, useRef } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import callApi from '../../helpers/apiCaller';
import config from '../../common/config';
import swal from 'sweetalert';
import $ from 'jquery';
import Cookies from 'universal-cookie';
//import MathJax from 'react-mathjax-preview';
import { MathJax, MathJaxContext, useMathJax } from "better-react-mathjax";
import HtmlParse from 'html-react-parser';
import _ from 'lodash';
//import HtmlParser from 'html-react-parser';
import moment from 'moment';
//import MathElement from "../../common/MathML1";
import 'antd/dist/antd.css';
//import { Image } from 'antd';
//import { divideSubjectType1 } from 'views/StudentExamTHPT2025/ChiaPhanMonThi';
import "../StudentExamTHPT2025/index.css"
import { showMessagePartTHPT } from '../../common/config';
import { divideSubjectType1, divideSubjectType2, divideSubjectType3, divideSubjectType4, divideSubjectType5, divideSubjectType5SubPart } from '../../common/config';

const useStyles = makeStyles(theme => ({
}));

const TeacherViewExam = props => {
  const [firstArray, setFirstArray] = useState([]);
  const [secondArray, setSecondArray] = useState([]);
  const [answerPart2, setAnswerPart2] = useState([]);
  const [thirdArray, setThirdArray] = useState([]);
  const [questionArr, setQuestionArr] = useState([]);
  const [firstArraySubPart, setFirstArraySubPart] = useState([]);
  const [secondArraySubPart, setSecondArraySubPart] = useState([]);
  const [thirdArraySubPart, setThirdArraySubPart] = useState([]);
  const [orientationType, setOrientationType] = useState(0);
  let answerMatch1 = []
  let answerMatch2 = []
  let answerMatch3 = []
  let answerMatch4 = []

  var cookies = new Cookies();
  var accessToken = cookies.get('access_token');
  if (accessToken == undefined) {
    //login gv
    accessToken = window.localStorage.getItem("AccessToken");
  }
  if (accessToken == undefined) {
    // hs
    accessToken = "";
  }
  var header = { authorization: accessToken }
  const { history } = props;

  const classes = useStyles();
  const [users, setUsers] = useState([]);
  const [exams, setExams] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [gid, setGID] = useState('');
  const [examRecordId, setExamRecordId] = useState('');
  const [disconnectNumber, setDisconnectNum] = useState(0);
  const [assignArrNext, setAssignArrNext] = useState('');
  const [username, setUsername] = useState('');
  const [schoolname, setSchoolname] = useState('');
  const [roomname, setRoomname] = useState('');
  const [examname, setExamname] = useState('');
  const [subjectname, setSubjectname] = useState('');
  const [durations, setDurations] = useState(0);
  const [totalDurations, setTotalDurations] = useState(0);
  const [currentMunutes, setCurrentMunutes] = useState(0);
  const [numOfQuestions, setNumOfQuestions] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [numCorrect, setNumCorrect] = useState(0);
  const [numIncorrect, setNumIncorrect] = useState(0);
  const [numUnfinish, setNumUnfinish] = useState(0);
  const [openFrom, setOpenFrom] = useState(0);
  const [score, setScore] = useState(0);
  const [spendMunutes, setSpendMunutes] = useState(0);
  const [spendSeconds, setSpendSeconds] = useState(0);
  const [viewAnswerAt, setViewAnswerAt] = useState(0);
  const examRecordIdCurrent = useRef('');
  const examRecordIdCurrentURL = useRef('');
  const questionTypeId = useRef(1);
  const statusCheckPoint = useRef(false); // status chấm điểm hay chưa
  const subjectId = useRef(0);
  const isFree = useRef(0);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  var userStore = {};

  let assignArr = '';
  var idUrl = '';
  var numOfQuestion = 0;
  var spendTime = 0;
  var checkExam = false;
  var refeshNum = 0;
  var outExam = 0;
  let gid_applyId = 0;
  let linkLogin = "/dang-nhap";

  let duration = 0;
  var current = 60;
  //var currentMunute = duration - 1 - spendTime / 60;
  var currentMunute = 0;
  var totalQuestion = parseInt(numOfQuestion);
  var totalDuration = parseInt(duration);
  var qArr = Array();
  var disconnectNum = 0;

  useEffect(async () => {

    var queryParams = config.getUrlQueryParams();
    if (queryParams[0].split('=')[1] == 0 || queryParams[0].split('=')[1] == undefined || queryParams[0].split('=')[1] == NaN) {
      setQuestions([]);
      swal("", "Bài thi không đúng. Vui lòng kiểm tra lại", "warning", {
        button: "OK",
      });
      return false;
    } else {
      examRecordIdCurrentURL.current = queryParams[1].split('=')[1];

      var body = {
        "gid": queryParams[0].split('=')[1],//exam id cua de thi
        "exam_record_id": queryParams[1].split('=')[1], //lấy last_exam_record_id từ cái API lấy list điểm của học sinh"
      }
      var apiBaseUrl = config.getRootURL() + '/gd/v3/manage_exams/student_view_test';
      config.showLoader();
      await callApi(apiBaseUrl, 'POST', body, header)
        .then(function (response) {
          if (response == false) {
            config.hideLoader();
            return false;
          }

          if (response.data.data.exam != undefined) {
            config.hideLoader();
            //if (response.data.data.exam.subject_id == 1) 
            //{
              // const ansPart2 = response.data.data.questions.slice(12, 16)?.map(question => ({
              //   id: question.id,
              //   answerOfStudent: question.answerOfStudent
              // }));
              setQuestionArr(response.data.data.questions)

              //// de thpt 2025
              // 1 Toán
              if (response.data.data.exam.subject_id === 1) {
                const dividePart = divideSubjectType1(response.data.data.questions)
                const { part1, part2, part3 } = dividePart;
                // setFirstArray(part1);
                // setSecondArray(part2);
                // setThirdArray(part3);
              }
              else if ( // 6 Lý, 7 Hóa, 9 Sinh, 11 Địa
                response.data.data.exam.subject_id === 6 ||
                response.data.data.exam.subject_id === 7 ||
                response.data.data.exam.subject_id === 9 ||
                response.data.data.exam.subject_id === 11
              ) {
                //const dividePart = divideSubjectType2(response.data.data.questions)
                //const { part1, part2, part3 } = dividePart;
                // setFirstArray(part1);
                // setSecondArray(part2);
                // setThirdArray(part3);                
              }
              else if ( // 10 Sử, 12 GDCD, 15 [CN công nghiệp, CN nông nghiệp], 31 Giáo dục kinh tế & Pháp luật
                response.data.data.exam.subject_id === 10 ||
                response.data.data.exam.subject_id === 12 ||
                response.data.data.exam.subject_id === 15 ||
                response.data.data.exam.subject_id === 31 
              ) {
                //const dividePart = divideSubjectType3(response.data.data.questions)
                //const { part1, part2 } = dividePart;
                // setFirstArray(part1);
                // setSecondArray(part2);
              }
              else if ( // 8 Anh
                response.data.data.exam.subject_id === 8
              ) {
                // const dividePart = divideSubjectType4(response.data.data.questions)
                // const { part1 } = dividePart;
                // setFirstArray(part1);
              }
              else if ( // 14 Tin
                response.data.data.exam.subject_id === 14
              ) {
                //const dividePart = divideSubjectType5(response.data.data.questions)
                //const { part1, part2 } = dividePart;
                //setFirstArray(part1);
                //setSecondArray(part2);

                //const divideSubPart = divideSubjectType5SubPart(part2);
                const divideSubPart = divideSubjectType5SubPart(response.data.data.questions.filter(x=>x.sub_question_type_id==2));
                const { subPart1, subPart2, subPart3 } = divideSubPart;
                setFirstArraySubPart(subPart1);
                setSecondArraySubPart(subPart2);
                setThirdArraySubPart(subPart3);
                // loai phan rieng: 1: dinh huong khoa hoc may tinh, 2: dinh huong tin hoc ung dung
                setOrientationType(response.data.data.exam.orientation_type);
              }

              setFirstArray(response.data.data.questions.filter(x=>x.sub_question_type_id==1));
              setSecondArray(response.data.data.questions.filter(x=>x.sub_question_type_id==2));
              setThirdArray(response.data.data.questions.filter(x=>x.sub_question_type_id==3));

            //}
            // ExamStatusQuaHan         = 20 // Qua han lam bai
            // ExamStatusThiNgay        = 21 // Thi ngay  => gv hiển thị thông báo "Chưa thi"
            // ExamStatusChuanBiMo      = 22 // Chuan bi mo
            // ExamStatusDaNopBai       = 23 // Da nop bai
            // ExamStatusLienHeGiaoVien = 24 // Lien he giao vien khi có gian lận
            // ExamStatusDangLamBai     = 25 //  Dang lam bai
            // ExamStatusQuaHanNopBai   = 26 // Qua han nop bai
            // ExamStatusDangChamBai    = 29 // Dang cham bai tu luan
            // ExamStatusDaChamBai      = 30 // Da cham bai tu luan xong
            var msg = "";
            switch (response.data.data.exam.cur_status) {
              case 20:
                msg = "Quá hạn làm bài. Vui lòng liên hệ giáo viên để được hổ trợ.";
                break;
              case 21:
                msg = "Bài thi đã mở. Vui lòng quay lại phòng thi.";
                break;
              case 22:
                msg = "Bài thi sắp mở. Vui lòng quay lại phòng thi.";
                break;
              case 24:
                msg = "Bài thi bị khóa. Vui lòng liên hệ giáo viên để được hổ trợ.";
                break;
              case 26:
                msg = "Quá hạn nộp bài. Vui lòng liên hệ giáo viên để được hổ trợ.";
                break;
              case 30:
                statusCheckPoint.current = true;
                break;
              default:
                break;
            }

            //dang de
            subjectId.current = response.data.data.exam.subject_id;
            isFree.current = response.data.data.exam?.is_free;
            examRecordIdCurrent.current = response.data.data.exam.last_exam_record_id;
            questionTypeId.current = response.data.data.exam.question_type_id

            // get id save []
            var num_finish = 0;
            response.data.data.questions.forEach((question, num) => {
              assignArr += `${question.id};`;

              if (questionTypeId.current == 3) {
                if (response.data.data.exam.result != null && (response.data.data.exam.result[examRecordIdCurrent.current] != null || response.data.data.exam.result[examRecordIdCurrent.current] != undefined)) {  // gang tam =0  => =3
                  var answerImages = response.data.data.exam.result[examRecordIdCurrent.current][question.id + '_images'];
                  var answerFiles = response.data.data.exam.result[examRecordIdCurrent.current][question.id + '_files'];

                  response.data.data.questions[num].answerImages = answerImages.split(",");
                  response.data.data.questions[num].answerFiles = answerFiles.split(",");
                  response.data.data.questions[num].answerOfStudentImages = answerImages;
                  response.data.data.questions[num].answerOfStudentFiles = answerFiles;
                  if (answerImages != "" || answerFiles != "" || question.answerOfStudent != "") {
                    response.data.data.questions[num].isAnswered = true;
                    num_finish += 1;
                  }
                }

                if (response.data.data.exam.teacher_grading != undefined && response.data.data.exam.teacher_grading != null) {
                  if (response.data.data.exam.teacher_grading[question.id] != undefined) {
                    response.data.data.questions[num].teacher_comment = response.data.data.exam.teacher_grading[question.id].teacher_comment;
                    response.data.data.questions[num].teacher_id = response.data.data.exam.teacher_grading[question.id].teacher_id;
                    response.data.data.questions[num].teacher_score = response.data.data.exam.teacher_grading[question.id].teacher_score;
                  } else {
                    response.data.data.questions[num].teacher_comment = '';
                    response.data.data.questions[num].teacher_id = 0;
                    response.data.data.questions[num].teacher_score = 0;
                  }
                }
                else {
                  response.data.data.questions[num].teacher_comment = '';
                  response.data.data.questions[num].teacher_id = 0;
                  response.data.data.questions[num].teacher_score = 0;
                }
              }
            });
            setQuestions(response.data.data.questions);
            setAssignArrNext(assignArr);

            // get info
            setExamRecordId(response.data.data.exam.last_exam_record_id);
            setGID(response.data.data.exam.gid);
            setSchoolname(response.data.data.exam.school_name);
            setUsername(response.data.data.exam.student_name)
            setRoomname(response.data.data.exam.room_name);
            setExamname(response.data.data.exam.exam_name);
            setSubjectname(response.data.data.exam.subject_name);
            setNumCorrect(response.data.data.exam.num_correct);
            setNumIncorrect(response.data.data.exam.num_incorrect);
            setNumUnfinish(response.data.data.exam.num_unfinish);
            setOpenFrom(response.data.data.exam.settings.open_from);
            setViewAnswerAt(response.data.data.exam.settings.view_answer_at);
            setScore(response.data.data.exam.score);

            numOfQuestion =  response.data.data.exam.num_correct + response.data.data.exam.num_incorrect + response.data.data.exam.num_unfinish ;//response.data.data.questions.length;
            totalQuestion = response.data.data.questions.length;

            duration = response.data.data.exam.settings.duration_in_seconds / 60;
            totalDuration = (response.data.data.exam.settings.duration_in_seconds) / 60;
            currentMunute = duration - 1 - response.data.data.exam.spend_time / 60;

            setSpendMunutes(response.data.data.exam.spend_time / 60);
            setSpendSeconds(response.data.data.exam.spend_time % 60);

            setDurations(duration);
            setTotalDurations(totalDuration);
            setCurrentMunutes(currentMunute);
            setCurrentMunutes(currentMunute);
            setNumOfQuestions(numOfQuestion);
            setTotalQuestions(totalQuestion);

            if (questionTypeId.current == 3) { // set lai
              setNumUnfinish(totalQuestion - num_finish);
            }
          }
          else if (response == undefined) {
            config.hideLoader();
            setQuestions([]);
            swal("", "Bài thi không đúng. Vui lòng kiểm tra lại", "warning", {
              button: "OK",
            });
            return false;
          }
          else {
            config.hideLoader();
          }
        })
        .catch(function (error) {
          config.hideLoader();
          console.log(error);
        });
    }

    // off public... script.js =>off menu
    if ($(window).width() < 768) {
      $('body').removeClass('menu-active');
    }

  }, []);

  // chọn cau hỏi add và remove class
  let currentQuestionId;

  function ShowHideFullExplain(event, id) {
    $('.fullexplain').removeClass('active');
    if ($('#fullexplaintext_' + id).text() == 'Hướng dẫn giải') {
      $('#fullexplain_' + id).addClass('active');
      $('#fullexplaintext_' + id).html('Tắt hướng dẫn giải');
    } else {
      $('#fullexplaintext_' + id).html('Hướng dẫn giải');
      $('#fullexplain_' + id).removeClass('active');
    }
  }


  function addClass(event, qId) {
    $('.btnq').removeClass('btnq-active');
    $(`#q_btn_${qId}`).addClass('btnq-active');

    $('.qItem').hide();
    $(`#questionRegionItem_${qId}`).show();
  }

  async function ErrorQuestion(event, id) {
    event.preventDefault();
    swal("", "Cám ơn bạn đã thông báo. Chúng tôi rất hy vọng nhận được nhiều phản hồi tích cực từ phía Thầy/Cô và các bạn.", "success", {
      button: "OK",
    });
    return false;

    var answers = `{${answers}}`;
    var body =
    {
      "gid": gid,// global id được trả về từ danh sách bài thi
    };

    const apiBaseUrl = config.getRootURL() + '/gd/v3/student_exams/';
    await callApi(apiBaseUrl, 'POST', body, header)
      .then(function (response) {
        if (response == false) {
          swal("", "Cám ơn bạn đã thông báo. Chúng tôi rất hy vọng nhận được nhiều phản hồi tích cực từ phía Thầy Cô và các em học sinh.", "warning", {
            button: "OK",
          });
          return false;
        }
        if (response != undefined) {
          swal("", "Cám ơn bạn đã thông báo. Chúng tôi rất hy vọng nhận được nhiều phản hồi tích cực từ phía Thầy Cô và các em học sinh.", "success", {
            button: "OK",
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  function getTime(s) {
    if (s > 9) {
      return s;
    }
    return `0${s}`;
  }

  function addClassPart2(event, qId, ques) {
    $('.btnq').removeClass('btnq-active');
    $(`#q_btn_${qId}${ques}`).addClass('btnq-active');

    $('.qItem').hide();
    $(`#questionRegionItem_${qId}`).show();

    ////////
    //$(`.qItemPart2-${qId}`).hide(); // off => show all a b c d 
    $(`.qItemPart2-${qId}`).removeClass('btnq-active');
    $(`#quesItemPart2${qId}${ques}`).addClass('btnq-active');
    /////////

    $(`#quesItemPart2${qId}${ques}`).show();
  }
  var resetSTT1 = 0;
  var resetSTT2 = 0;

  const mathJaxConfig = {
    loader: { load: ["input/asciimath", "output/chtml"] },
  };

  return (
    <div>
      <div className="wrapper">
        <div className="block-question-wrap">
          <div className="block-question">
            <div className="info-mb">
              <ul className="info">
                <li><strong>{username}</strong></li>
                <li>{schoolname}</li>
                <li><strong>Phòng thi: {roomname}</strong></li>
              </ul>
            </div>
            {
              questionTypeId.current == 3 ? // essay
                <div className="block-result essay">
                  {
                    statusCheckPoint.current == true ?
                      <div className="point" style={{ display: 'grid' }}>
                        <span>Tổng điểm</span>
                        <strong>{score.toFixed(2)}</strong>
                      </div>
                      : ""
                  }
                  <ul className="info">
                    <li>
                      <h1><strong>Môn thi {subjectname} - {examname}</strong></h1>
                    </li>
                    <li>Ngày thi: <strong> {moment(openFrom).format('DD/MM/YYYY HH:mm')}</strong></li>
                    <li>Thời gian thi: <strong>{durations} Phút - {numOfQuestions} Câu</strong></li>
                    <li>Số câu chưa làm: <span className="color-yellow">{numUnfinish}</span></li>
                    {
                      statusCheckPoint.current == false ?
                        <li>
                          <div className="imt-15 ip-15 rounded-8 ibg-e5f8ed itext-1a7c46">
                            Chúc mừng bạn đã hoàn thành bài thi, kết quả sẽ hiển thị trong danh sách bài thi đã hoàn thành sau khi bài thi được giáo viên chấm đểm.
                          </div>
                        </li> : ""
                    }
                  </ul>
                </div>
                :
                // trắc nghiem
                <div className="block-result">
                  <div className="point" style={{ display: 'grid' }}>
                    <span>Tổng điểm</span>
                    <strong>{score.toFixed(2)}</strong>
                  </div>
                  <ul className="info">
                    <li><h1 className="page-heading">Môn thi {subjectname} - {examname}</h1></li>
                    <li>Ngày thi: <strong> {moment(openFrom).format('DD/MM/YYYY HH:mm')}</strong></li>
                    <li>Thời gian thi: <strong>{durations} Phút - {numOfQuestions} Câu</strong></li>
                    <li>Số câu đúng: <span className="color-green">{numCorrect}</span> | Số câu sai <span className="color-red">{numIncorrect}</span> | Số câu chưa làm: <span className="color-yellow">{numUnfinish}</span></li>
                  </ul>
                </div>
            }
            {/* Phần đáp án hiển thị cho học sinh */}
            {
              <div className="page-body mb-30">
                {
                  questionArr?.map((question, num) => {
                    // Kiểm tra xem câu hỏi thuộc mảng nào
                    if (firstArray?.includes(question)) {
                      return (
                        <div className="qItem" id={`questionRegionItem_${question.id}`} style={num > 0 ? { display: 'none' } : { display: 'block' }}>
                          <h6>
                            <strong>Phần I.</strong>{showMessagePartTHPT(subjectId.current, 1, firstArray.length)}
                          </h6>
                          <br></br>
                          <div className="question-header">
                            <h2><span style={{ fontWeight: 'bold', color: 'blue' }}>CÂU {num + 1} </span></h2>
                          </div>
                          {
                            question.content.replace(/<style[^>]*>.*<\/style>/gm, '').length > 2000
                              ?
                              <div className="question overlay-scrollbar" style={{ height: '210px' }}>
                                {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                              </div>
                              :
                              <div className="question overlay-scrollbar" style={{ height: 'auto', marginBottom: '40px' }}>
                                {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>
                              </div>
                          }
                          <div className="answer style-checkbox">
                            <input type="hidden" id={`hidden_${question.id}`} name={`hidden_${question.id}`} className="hiddenQIDCSS" data-id={question.id}
                              defaultValue={question.answerOfStudent} />
                            <ul>
                              <li
                                className=
                                {
                                  question.answerOfStudent == 'A'
                                    ? question.isRight == false
                                      ? 'false'
                                      : 'true'
                                    : question.ar == 'A'
                                      ? 'true'
                                      : ''
                                }
                              >
                                <input disabled id={`q_${question.id}A`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={question.answerOfStudent == 'A' ? 'checked' : ''} />
                                <label htmlFor={`q_${question.id}A`} style={{ display: '-webkit-box' }} className="d-unset">
                                  <strong>A.&nbsp;</strong>
                                  {/* <MathJax math={question.a1.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a1.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                </label>
                              </li>
                              <li
                                className=
                                {
                                  question.answerOfStudent == 'B'
                                    ? question.isRight == false
                                      ? 'false'
                                      : 'true'
                                    : question.ar == 'B'
                                      ? 'true'
                                      : ''
                                }
                              >
                                <input disabled id={`q_${question.id}B`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={question.answerOfStudent == 'B' ? 'checked' : ''} />
                                <label htmlFor={`q_${question.id}B`} style={{ display: '-webkit-box' }} className="d-unset">
                                  <strong>B.&nbsp;</strong>
                                  {/* <MathJax math={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a2.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                </label>
                              </li>
                              <li
                                className=
                                {
                                  question.answerOfStudent == 'C'
                                    ? question.isRight == false
                                      ? 'false'
                                      : 'true'
                                    : question.ar == 'C'
                                      ? 'true'
                                      : ''
                                }
                              >
                                <input disabled id={`q_${question.id}C`} defaultValue="C" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={question.answerOfStudent == 'C' ? 'checked' : ''} />
                                <label htmlFor={`q_${question.id}C`} style={{ display: '-webkit-box' }} className="d-unset">
                                  <strong>C.&nbsp;</strong>
                                  {/* <MathJax math={question.a3.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a3.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                </label>
                              </li>
                              <li
                                className=
                                {
                                  question.answerOfStudent == 'D'
                                    ? question.isRight == false
                                      ? 'false'
                                      : 'true'
                                    : question.ar == 'D'
                                      ? 'true'
                                      : ''
                                }
                              >
                                <input disabled id={`q_${question.id}D`} defaultValue="D" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={question.answerOfStudent == 'D' ? 'checked' : ''} />
                                <label htmlFor={`q_${question.id}D`} style={{ display: '-webkit-box' }} className="d-unset">
                                  <strong>D.&nbsp;</strong>
                                  {/* <MathJax math={question.a4.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a4.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                </label>
                              </li>
                            </ul>
                            <br></br>
                            <div className="btn-wrap mb-30">
                              <a href="javascript:void(0);" id={"fullexplaintext_" + question.id} className="btn btn-secondary btn-ins" onClick={e => ShowHideFullExplain(e, question.id)}>Hướng dẫn giải</a>
                            </div>
                            <div className="block-text mb-30 fullexplain" id={"fullexplain_" + question.id}>
                              <div className="text-inner overlay-scrollbar">
                                {/* <MathJax math={question.full_explain.split('<p>&nbsp;</p>').join('')} /> */}
                                <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.full_explain.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else if (secondArray?.includes(question)) {
                      resetSTT1 +=1;
                      if(subjectId.current == 14  && isFree.current == false ) { // tin hoc
                        if(firstArraySubPart.includes(question)){
                          return (
                            <div className="qItem" id={`questionRegionItem_${question.id}`} style={num > 0 ? { display: 'none' } : { display: 'block' }}>
                              <h6>
                              <p><strong>Phần II.{showMessagePartTHPT(subjectId.current, 2, firstArraySubPart.length)}</strong></p>
                                <strong>A/ Phần chung</strong>
                              </h6>
                              <br></br>
                              <div className="question-header">
                                <h2><span style={{ fontWeight: 'bold', color: 'blue' }}>
                                  {/* CÂU {num + 1}  */}
                                  CÂU {resetSTT1}
                                </span></h2>
                              </div>
                              {
                                question.content.replace(/<style[^>]*>.*<\/style>/gm, '').length > 2000
                                  ?
                                  <div className="question overlay-scrollbar" style={{ height: '210px' }}>
                                    {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                    <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                  </div>
                                  :
                                  <div className="question overlay-scrollbar" style={{ height: 'auto', marginBottom: '40px' }}>
                                    {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                    <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                  </div>
                              }
                              {
                                <div className="answer">
                                  {["a1", "a2", "a3", "a4"].map((item, nump2) => (
                                    <ul className='test-number-part2'>
                                      <li
                                        key={nump2}
                                        id={`quesItemPart2${question.id}${item}`}
                                        className={`qItemPart2-${question.id}`}
                                        // style={nump2 > 0 ? { display: 'none' } : { display: 'block' }}
                                        style={nump2 > 0 ? { display: 'block' } : { display: 'block' }}
                                      >
                                        {
                                          item === "a1" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>a. </span> 
                                              {/* <MathJax math={question.a1.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a1.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>
                                            </div>
                                          :
                                          item === "a2" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>b. </span> 
                                            {/* <MathJax math={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a2.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>
                                            </div>
                                          :
                                          item === "a3" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>c. </span> 
                                            {/* <MathJax math={question.a3.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a3.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>
                                            </div>
                                          :
                                          item === "a4" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>d. </span> 
                                              {/* <MathJax math={question.a4.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a4.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>
                                            </div>
                                          : ""
                                        }
                                        <input type="hidden" id={`hidden_${question.id}`} name={`hidden_${question.id}`} className="hiddenQIDCSS" data-id={question.id}
                                          defaultValue={question.answerOfStudent} />
                                        <ul className='answer-true-false' style={{ marginTop: "10px", display: "flex", justifyContent: "left", gap: "10px" }}>
                                          {
                                            item === "a1" ?
                                              <>
                                                <li
                                                    className={
                                                      (() => {
                                                        answerMatch1 = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                                        if (answerMatch1) {
                                                          const answer = answerMatch1[1] // Lấy giá trị "ĐÚNG" hoặc "SAI"
                                                          if (answer == "ĐÚNG") {
                                                            return _.upperCase(question.ara) === 'ĐÚNG' ? 'true' : 'false'
                                                          }
                                                        }
                                                        return _.upperCase(question.ara) === 'ĐÚNG' ? 'true' : ""
                                                      })()
                                                    }
                                                  >
                                                  <input disabled id={`q_${question.id}a1`} defaultValue="ĐÚNG" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch1 ? (answerMatch1[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a1`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  className={
                                                    (() => {
                                                      answerMatch1 = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                                      if (answerMatch1) {
                                                        const answer = answerMatch1[1]
                                                        if (answer == "SAI") {
                                                          return _.upperCase(question.ara) === 'SAI' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.ara) === 'SAI' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a1`} defaultValue="SAI" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch1 ? (answerMatch1[1] === 'SAI' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a1`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>B. SAI</strong>
                                                  </label>
                                                </li>
                                              </>
                                              :
                                              item === "a2" ?
                                              <>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch2 = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                                      if (answerMatch2) {
                                                        const answer = answerMatch2[1]
                                                        if (answer == "ĐÚNG") {
                                                          return _.upperCase(question.arb) === 'ĐÚNG' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arb) === 'ĐÚNG' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a2`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch2 ? (answerMatch2[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a2`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch2 = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                                      if (answerMatch2) {
                                                        const answer = answerMatch2[1]
                                                        if (answer == "SAI") {
                                                          return _.upperCase(question.arb) === 'SAI' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arb) === 'SAI' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a2`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch2 ? (answerMatch2[1] === 'SAI' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a2`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>B.SAI</strong>
                                                    {/* <MathElement elements={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                                  </label>
                                                </li></>
                                              :
                                              item === "a3" ?
                                              <>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch3 = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                                      if (answerMatch3) {
                                                        const answer = answerMatch3[1]
                                                        if (answer == "ĐÚNG") {
                                                          return _.upperCase(question.arc) === 'ĐÚNG' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arc) === 'ĐÚNG' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a3`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch3 ? (answerMatch3[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a3`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch3 = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                                      if (answerMatch3) {
                                                        const answer = answerMatch3[1]
                                                        if (answer == "SAI") {
                                                          return _.upperCase(question.arc) === 'SAI' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arc) === 'SAI' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a3`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch3 ? (answerMatch3[1] === 'SAI' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a3`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>B.SAI</strong>
                                                  </label>
                                                </li></>
                                              :
                                              item === "a4" ?
                                                <><li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch4 = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                                      if (answerMatch4) {
                                                        const answer = answerMatch4[1]
                                                        if (answer == "ĐÚNG") {
                                                          return _.upperCase(question.ard) === 'ĐÚNG' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.ard) === 'ĐÚNG' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a4`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch4 ? (answerMatch4[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a4`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                  <li
                                                    className=
                                                    {
                                                      (() => {
                                                        answerMatch4 = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                                        if (answerMatch4) {
                                                          const answer = answerMatch4[1]
                                                          if (answer == "SAI") {
                                                            return _.upperCase(question.ard) === 'SAI' ? 'true' : 'false'
                                                          }
                                                        }
                                                        return _.upperCase(question.ard) === 'SAI' ? 'true' : ""
                                                      })()
                                                    }
                                                  >
                                                    <input disabled id={`q_${question.id}a4`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch4 ? (answerMatch4[1] === 'SAI' ? 'checked' : '') : ''} />
                                                    <label htmlFor={`q_${question.id}a4`} style={{ display: '-webkit-box' }} className="d-unset">
                                                      <strong>B.SAI</strong>
                                                    </label>
                                                  </li></>
                                            : "không có đáp án"
                                          }

                                        </ul>
                                        <br></br>
                                        <div style={nump2==3 ? {display:''}:{display:'none'}}>
                                          <div className="btn-wrap mb-30">
                                            <a href="javascript:void(0);" id={"fullexplaintext_" + question.id + "_" + nump2} className="btn btn-secondary btn-ins" onClick={e => ShowHideFullExplain(e, question.id + "_" + nump2)}>Hướng dẫn giải</a>
                                          </div>
                                          <div className="block-text mb-30 fullexplain" id={"fullexplain_" + question.id + "_" + nump2}>
                                            <div className="text-inner overlay-scrollbar">
                                              {/* <MathJax math={question.full_explain.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.full_explain.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  ))}
                                </div>
                              }
                            </div>
                          )
                        }
                        if(secondArraySubPart.includes(question)){
                          return (
                            <div className="qItem" id={`questionRegionItem_${question.id}`} style={num > 0 ? { display: 'none' } : { display: 'block' }}>
                              <h6>
                              <p><strong>Phần II.{showMessagePartTHPT(subjectId.current, 2, secondArraySubPart.length)}</strong></p>
                                <strong>B/ Phần riêng: Định hướng khoa học máy tính</strong>
                              </h6>
                              <br></br>
                              <div className="question-header">
                                <h2><span style={{ fontWeight: 'bold', color: 'blue' }}>
                                  {/* CÂU {num + 1}  */}
                                  CÂU {resetSTT1}
                                </span></h2>
                              </div>
                              {
                                question.content.replace(/<style[^>]*>.*<\/style>/gm, '').length > 2000
                                  ?
                                  <div className="question overlay-scrollbar" style={{ height: '210px' }}>
                                    {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                    <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                  </div>
                                  :
                                  <div className="question overlay-scrollbar" style={{ height: 'auto', marginBottom: '40px' }}>
                                    {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                    <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                  </div>
                              }
                              {
                                <div className="answer">
                                  {["a1", "a2", "a3", "a4"].map((item, nump2) => (
                                    <ul className='test-number-part2'>
                                      <li
                                        key={nump2}
                                        id={`quesItemPart2${question.id}${item}`}
                                        className={`qItemPart2-${question.id}`}
                                        // style={nump2 > 0 ? { display: 'none' } : { display: 'block' }}
                                        style={nump2 > 0 ? { display: 'block' } : { display: 'block' }}
                                      >
                                        {
                                          item === "a1" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>a. </span> 
                                            {/* <MathJax math={question.a1.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a1.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                            </div>
                                          :
                                          item === "a2" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>b. </span> 
                                            {/* <MathJax math={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                            <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a2.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                            </div>
                                          :
                                          item === "a3" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>c. </span> 
                                            {/* <MathJax math={question.a3.split('<p>&nbsp;</p>').join('')} /> */}
                                            <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a3.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                            </div>
                                          :
                                          item === "a4" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>d. </span> 
                                            {/* <MathJax math={question.a4.split('<p>&nbsp;</p>').join('')} /> */}
                                            <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a4.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                            </div>
                                          : ""
                                        }
                                        <input type="hidden" id={`hidden_${question.id}`} name={`hidden_${question.id}`} className="hiddenQIDCSS" data-id={question.id}
                                          defaultValue={question.answerOfStudent} />
                                        <ul className='answer-true-false' style={{ marginTop: "10px", display: "flex", justifyContent: "left", gap: "10px" }}>
                                          {
                                            item === "a1" ?
                                              <>
                                                <li
                                                    className={
                                                      (() => {
                                                        answerMatch1 = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                                        if (answerMatch1) {
                                                          const answer = answerMatch1[1] // Lấy giá trị "ĐÚNG" hoặc "SAI"
                                                          if (answer == "ĐÚNG") {
                                                            return _.upperCase(question.ara) === 'ĐÚNG' ? 'true' : 'false'
                                                          }
                                                        }
                                                        return _.upperCase(question.ara) === 'ĐÚNG' ? 'true' : ""
                                                      })()
                                                    }
                                                  >
                                                  <input disabled id={`q_${question.id}a1`} defaultValue="ĐÚNG" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch1 ? (answerMatch1[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a1`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  className={
                                                    (() => {
                                                      answerMatch1 = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                                      if (answerMatch1) {
                                                        const answer = answerMatch1[1]
                                                        if (answer == "SAI") {
                                                          return _.upperCase(question.ara) === 'SAI' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.ara) === 'SAI' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a1`} defaultValue="SAI" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch1 ? (answerMatch1[1] === 'SAI' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a1`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>B. SAI</strong>
                                                  </label>
                                                </li>
                                              </>
                                              :
                                              item === "a2" ?
                                              <>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch2 = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                                      if (answerMatch2) {
                                                        const answer = answerMatch2[1]
                                                        if (answer == "ĐÚNG") {
                                                          return _.upperCase(question.arb) === 'ĐÚNG' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arb) === 'ĐÚNG' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a2`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch2 ? (answerMatch2[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a2`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch2 = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                                      if (answerMatch2) {
                                                        const answer = answerMatch2[1]
                                                        if (answer == "SAI") {
                                                          return _.upperCase(question.arb) === 'SAI' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arb) === 'SAI' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a2`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch2 ? (answerMatch2[1] === 'SAI' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a2`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>B.SAI</strong>
                                                    {/* <MathElement elements={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                                  </label>
                                                </li></>
                                              :
                                              item === "a3" ?
                                              <>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch3 = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                                      if (answerMatch3) {
                                                        const answer = answerMatch3[1]
                                                        if (answer == "ĐÚNG") {
                                                          return _.upperCase(question.arc) === 'ĐÚNG' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arc) === 'ĐÚNG' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a3`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch3 ? (answerMatch3[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a3`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch3 = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                                      if (answerMatch3) {
                                                        const answer = answerMatch3[1]
                                                        if (answer == "SAI") {
                                                          return _.upperCase(question.arc) === 'SAI' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arc) === 'SAI' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a3`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch3 ? (answerMatch3[1] === 'SAI' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a3`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>B.SAI</strong>
                                                  </label>
                                                </li></>
                                              :
                                              item === "a4" ?
                                                <><li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch4 = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                                      if (answerMatch4) {
                                                        const answer = answerMatch4[1]
                                                        if (answer == "ĐÚNG") {
                                                          return _.upperCase(question.ard) === 'ĐÚNG' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.ard) === 'ĐÚNG' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a4`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch4 ? (answerMatch4[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a4`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                  <li
                                                    className=
                                                    {
                                                      (() => {
                                                        answerMatch4 = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                                        if (answerMatch4) {
                                                          const answer = answerMatch4[1]
                                                          if (answer == "SAI") {
                                                            return _.upperCase(question.ard) === 'SAI' ? 'true' : 'false'
                                                          }
                                                        }
                                                        return _.upperCase(question.ard) === 'SAI' ? 'true' : ""
                                                      })()
                                                    }
                                                  >
                                                    <input disabled id={`q_${question.id}a4`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch4 ? (answerMatch4[1] === 'SAI' ? 'checked' : '') : ''} />
                                                    <label htmlFor={`q_${question.id}a4`} style={{ display: '-webkit-box' }} className="d-unset">
                                                      <strong>B.SAI</strong>
                                                    </label>
                                                  </li></>
                                            : "không có đáp án"
                                          }

                                        </ul>
                                        <br></br>
                                        <div style={nump2==3 ? {display:''}:{display:'none'}}>
                                          <div className="btn-wrap mb-30">
                                            <a href="javascript:void(0);" id={"fullexplaintext_" + question.id + "_" + nump2} className="btn btn-secondary btn-ins" onClick={e => ShowHideFullExplain(e, question.id + "_" + nump2)}>Hướng dẫn giải</a>
                                          </div>
                                          <div className="block-text mb-30 fullexplain" id={"fullexplain_" + question.id + "_" + nump2}>
                                            <div className="text-inner overlay-scrollbar">
                                              {/* <MathJax math={question.full_explain.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.full_explain.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  ))}
                                </div>
                              }
                            </div>
                          );
                        }
                        if(thirdArraySubPart.includes(question)){
                          return (
                            <div className="qItem" id={`questionRegionItem_${question.id}`} style={num > 0 ? { display: 'none' } : { display: 'block' }}>
                              <h6>
                                  <p><strong>Phần II. {showMessagePartTHPT(subjectId.current, 2, thirdArraySubPart.length)}</strong></p>
                                  <strong>B/ Phần riêng: Định hướng Tin học ứng dụng</strong>
                                </h6>
                              <br></br>
                              <div className="question-header">
                                <h2><span style={{ fontWeight: 'bold', color: 'blue' }}>
                                  {/* CÂU {num + 1}  */}
                                  CÂU {resetSTT1}
                                </span></h2>
                              </div>
                              {
                                question.content.replace(/<style[^>]*>.*<\/style>/gm, '').length > 2000
                                  ?
                                  <div className="question overlay-scrollbar" style={{ height: '210px' }}>
                                    {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                    <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                  </div>
                                  :
                                  <div className="question overlay-scrollbar" style={{ height: 'auto', marginBottom: '40px' }}>
                                    {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                    <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                  </div>
                              }
                              {
                                <div className="answer">
                                  {["a1", "a2", "a3", "a4"].map((item, nump2) => (
                                    <ul className='test-number-part2'>
                                      <li
                                        key={nump2}
                                        id={`quesItemPart2${question.id}${item}`}
                                        className={`qItemPart2-${question.id}`}
                                        // style={nump2 > 0 ? { display: 'none' } : { display: 'block' }}
                                        style={nump2 > 0 ? { display: 'block' } : { display: 'block' }}
                                      >
                                        {
                                          item === "a1" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>a. </span> 
                                            {/* <MathJax math={question.a1.split('<p>&nbsp;</p>').join('')} /> */}
                                            <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a1.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                            </div>
                                          :
                                          item === "a2" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>b. </span> 
                                            {/* <MathJax math={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                            <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a2.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                            </div>
                                          :
                                          item === "a3" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>c. </span> 
                                            {/* <MathJax math={question.a3.split('<p>&nbsp;</p>').join('')} /> */}
                                            <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a3.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                            </div>
                                          :
                                          item === "a4" ?
                                            <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>d. </span> 
                                            {/* <MathJax math={question.a4.split('<p>&nbsp;</p>').join('')} /> */}
                                            <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a4.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                            </div>
                                          : ""
                                        }
                                        <input type="hidden" id={`hidden_${question.id}`} name={`hidden_${question.id}`} className="hiddenQIDCSS" data-id={question.id}
                                          defaultValue={question.answerOfStudent} />
                                        <ul className='answer-true-false' style={{ marginTop: "10px", display: "flex", justifyContent: "left", gap: "10px" }}>
                                          {
                                            item === "a1" ?
                                              <>
                                                <li
                                                    className={
                                                      (() => {
                                                        answerMatch1 = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                                        if (answerMatch1) {
                                                          const answer = answerMatch1[1] // Lấy giá trị "ĐÚNG" hoặc "SAI"
                                                          if (answer == "ĐÚNG") {
                                                            return _.upperCase(question.ara) === 'ĐÚNG' ? 'true' : 'false'
                                                          }
                                                        }
                                                        return _.upperCase(question.ara) === 'ĐÚNG' ? 'true' : ""
                                                      })()
                                                    }
                                                  >
                                                  <input disabled id={`q_${question.id}a1`} defaultValue="ĐÚNG" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch1 ? (answerMatch1[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a1`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  className={
                                                    (() => {
                                                      answerMatch1 = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                                      if (answerMatch1) {
                                                        const answer = answerMatch1[1]
                                                        if (answer == "SAI") {
                                                          return _.upperCase(question.ara) === 'SAI' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.ara) === 'SAI' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a1`} defaultValue="SAI" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch1 ? (answerMatch1[1] === 'SAI' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a1`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>B. SAI</strong>
                                                  </label>
                                                </li>
                                              </>
                                              :
                                              item === "a2" ?
                                              <>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch2 = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                                      if (answerMatch2) {
                                                        const answer = answerMatch2[1]
                                                        if (answer == "ĐÚNG") {
                                                          return _.upperCase(question.arb) === 'ĐÚNG' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arb) === 'ĐÚNG' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a2`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch2 ? (answerMatch2[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a2`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch2 = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                                      if (answerMatch2) {
                                                        const answer = answerMatch2[1]
                                                        if (answer == "SAI") {
                                                          return _.upperCase(question.arb) === 'SAI' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arb) === 'SAI' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a2`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch2 ? (answerMatch2[1] === 'SAI' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a2`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>B.SAI</strong>
                                                    {/* <MathElement elements={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                                  </label>
                                                </li></>
                                              :
                                              item === "a3" ?
                                              <>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch3 = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                                      if (answerMatch3) {
                                                        const answer = answerMatch3[1]
                                                        if (answer == "ĐÚNG") {
                                                          return _.upperCase(question.arc) === 'ĐÚNG' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arc) === 'ĐÚNG' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a3`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch3 ? (answerMatch3[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a3`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch3 = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                                      if (answerMatch3) {
                                                        const answer = answerMatch3[1]
                                                        if (answer == "SAI") {
                                                          return _.upperCase(question.arc) === 'SAI' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arc) === 'SAI' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a3`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch3 ? (answerMatch3[1] === 'SAI' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a3`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>B.SAI</strong>
                                                  </label>
                                                </li></>
                                              :
                                              item === "a4" ?
                                                <><li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch4 = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                                      if (answerMatch4) {
                                                        const answer = answerMatch4[1]
                                                        if (answer == "ĐÚNG") {
                                                          return _.upperCase(question.ard) === 'ĐÚNG' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.ard) === 'ĐÚNG' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a4`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch4 ? (answerMatch4[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a4`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                  <li
                                                    className=
                                                    {
                                                      (() => {
                                                        answerMatch4 = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                                        if (answerMatch4) {
                                                          const answer = answerMatch4[1]
                                                          if (answer == "SAI") {
                                                            return _.upperCase(question.ard) === 'SAI' ? 'true' : 'false'
                                                          }
                                                        }
                                                        return _.upperCase(question.ard) === 'SAI' ? 'true' : ""
                                                      })()
                                                    }
                                                  >
                                                    <input disabled id={`q_${question.id}a4`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch4 ? (answerMatch4[1] === 'SAI' ? 'checked' : '') : ''} />
                                                    <label htmlFor={`q_${question.id}a4`} style={{ display: '-webkit-box' }} className="d-unset">
                                                      <strong>B.SAI</strong>
                                                    </label>
                                                  </li></>
                                            : "không có đáp án"
                                          }

                                        </ul>
                                        <br></br>
                                        <div style={nump2==3 ? {display:''}:{display:'none'}}>
                                          <div className="btn-wrap mb-30">
                                            <a href="javascript:void(0);" id={"fullexplaintext_" + question.id + "_" + nump2} className="btn btn-secondary btn-ins" onClick={e => ShowHideFullExplain(e, question.id + "_" + nump2)}>Hướng dẫn giải</a>
                                          </div>
                                          <div className="block-text mb-30 fullexplain" id={"fullexplain_" + question.id + "_" + nump2}>
                                            <div className="text-inner overlay-scrollbar">
                                              {/* <MathJax math={question.full_explain.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.full_explain.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  ))}
                                </div>
                              }
                            </div>
                          );
                        }
                      } // end mon tin hoc
                      else {
                        return (
                          <div className="qItem" id={`questionRegionItem_${question.id}`} style={num > 0 ? { display: 'none' } : { display: 'block' }}>
                            <h6>
                              <strong>Phần II.</strong>{showMessagePartTHPT(subjectId.current, 2, secondArray.length)}
                            </h6>
                            <br></br>
                            <div className="question-header">
                              <h2><span style={{ fontWeight: 'bold', color: 'blue' }}>
                                {/* CÂU {num + 1}  */}
                                CÂU {resetSTT1}
                              </span></h2>
                            </div>
                            {
                              question.content.replace(/<style[^>]*>.*<\/style>/gm, '').length > 2000
                                ?
                                <div className="question overlay-scrollbar" style={{ height: '210px' }}>
                                  {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                </div>
                                :
                                <div className="question overlay-scrollbar" style={{ height: 'auto', marginBottom: '40px' }}>
                                  {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                </div>
                            }
                            {
                              <div className="answer">
                                {["a1", "a2", "a3", "a4"].map((item, nump2) => (
                                  <ul className='test-number-part2'>
                                    <li
                                      key={nump2}
                                      id={`quesItemPart2${question.id}${item}`}
                                      className={`qItemPart2-${question.id}`}
                                      // style={nump2 > 0 ? { display: 'none' } : { display: 'block' }}
                                      style={nump2 > 0 ? { display: 'block' } : { display: 'block' }}
                                    >
                                      {
                                        item === "a1" ?
                                          <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>a. </span> 
                                          {/* <MathJax math={question.a1.split('<p>&nbsp;</p>').join('')} /> */}
                                          <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a1.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                          </div>
                                        :
                                        item === "a2" ?
                                          <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>b. </span> 
                                          {/* <MathJax math={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                          <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a2.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                          </div>
                                        :
                                        item === "a3" ?
                                          <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>c. </span> 
                                          {/* <MathJax math={question.a3.split('<p>&nbsp;</p>').join('')} /> */}
                                          <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a3.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                          </div>
                                        :
                                        item === "a4" ?
                                          <div style={{display:'flex'}}> <span style={{paddingRight:'6px', paddingLeft:'8px'}}>d. </span> 
                                          {/* <MathJax math={question.a4.split('<p>&nbsp;</p>').join('')} /> */}
                                          <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.a4.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                          </div>
                                        : ""
                                      }
                                      <input type="hidden" id={`hidden_${question.id}`} name={`hidden_${question.id}`} className="hiddenQIDCSS" data-id={question.id}
                                        defaultValue={question.answerOfStudent} />
                                      <ul className='answer-true-false' style={{ marginTop: "10px", display: "flex", justifyContent: "left", gap: "10px" }}>
                                        {
                                          item === "a1" ?
                                            <><li
                                              className={
                                                (() => {
                                                  answerMatch1 = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                                  if (answerMatch1) {
                                                    const answer = answerMatch1[1] // Lấy giá trị "ĐÚNG" hoặc "SAI"
                                                    if (answer == "ĐÚNG") {
                                                      return _.upperCase(question.ara) === 'ĐÚNG' ? 'true' : 'false'
                                                    }
                                                  }
                                                  return _.upperCase(question.ara) === 'ĐÚNG' ? 'true' : ""
                                                })()
                                              }
                                            >
                                              <input disabled id={`q_${question.id}a1`} defaultValue="ĐÚNG" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch1 ? (answerMatch1[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                              <label htmlFor={`q_${question.id}a1`} style={{ display: '-webkit-box' }} className="d-unset">
                                                <strong>A.ĐÚNG</strong>
                                              </label>
                                            </li>
                                              <li
                                                className={
                                                  (() => {
                                                    answerMatch1 = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                                    if (answerMatch1) {
                                                      const answer = answerMatch1[1]
                                                      if (answer == "SAI") {
                                                        return _.upperCase(question.ara) === 'SAI' ? 'true' : 'false'
                                                      }
                                                    }
                                                    return _.upperCase(question.ara) === 'SAI' ? 'true' : ""
                                                  })()
                                                }
                                              >
                                                <input disabled id={`q_${question.id}a1`} defaultValue="SAI" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch1 ? (answerMatch1[1] === 'SAI' ? 'checked' : '') : ''} />
                                                <label htmlFor={`q_${question.id}a1`} style={{ display: '-webkit-box' }} className="d-unset">
                                                  <strong>B. SAI</strong>
                                                </label>
                                              </li>
                                            </>
                                            :
                                            item === "a2" ?
                                              <>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch2 = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                                      if (answerMatch2) {
                                                        const answer = answerMatch2[1]
                                                        if (answer == "ĐÚNG") {
                                                          return _.upperCase(question.arb) === 'ĐÚNG' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arb) === 'ĐÚNG' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a2`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch2 ? (answerMatch2[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a2`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>A.ĐÚNG</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  className=
                                                  {
                                                    (() => {
                                                      answerMatch2 = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                                      if (answerMatch2) {
                                                        const answer = answerMatch2[1]
                                                        if (answer == "SAI") {
                                                          return _.upperCase(question.arb) === 'SAI' ? 'true' : 'false'
                                                        }
                                                      }
                                                      return _.upperCase(question.arb) === 'SAI' ? 'true' : ""
                                                    })()
                                                  }
                                                >
                                                  <input disabled id={`q_${question.id}a2`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch2 ? (answerMatch2[1] === 'SAI' ? 'checked' : '') : ''} />
                                                  <label htmlFor={`q_${question.id}a2`} style={{ display: '-webkit-box' }} className="d-unset">
                                                    <strong>B.SAI</strong>
                                                    {/* <MathElement elements={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                                  </label>
                                                </li></>
                                              :
                                              item === "a3" ?
                                                <>
                                                  <li
                                                    className=
                                                    {
                                                      (() => {
                                                        answerMatch3 = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                                        if (answerMatch3) {
                                                          const answer = answerMatch3[1]
                                                          if (answer == "ĐÚNG") {
                                                            return _.upperCase(question.arc) === 'ĐÚNG' ? 'true' : 'false'
                                                          }
                                                        }
                                                        return _.upperCase(question.arc) === 'ĐÚNG' ? 'true' : ""
                                                      })()
                                                    }
                                                  >
                                                    <input disabled id={`q_${question.id}a3`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch3 ? (answerMatch3[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                    <label htmlFor={`q_${question.id}a3`} style={{ display: '-webkit-box' }} className="d-unset">
                                                      <strong>A.ĐÚNG</strong>
                                                    </label>
                                                  </li>
                                                  <li
                                                    className=
                                                    {
                                                      (() => {
                                                        answerMatch3 = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                                        if (answerMatch3) {
                                                          const answer = answerMatch3[1]
                                                          if (answer == "SAI") {
                                                            return _.upperCase(question.arc) === 'SAI' ? 'true' : 'false'
                                                          }
                                                        }
                                                        return _.upperCase(question.arc) === 'SAI' ? 'true' : ""
                                                      })()
                                                    }
                                                  >
                                                    <input disabled id={`q_${question.id}a3`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch3 ? (answerMatch3[1] === 'SAI' ? 'checked' : '') : ''} />
                                                    <label htmlFor={`q_${question.id}a3`} style={{ display: '-webkit-box' }} className="d-unset">
                                                      <strong>B.SAI</strong>
                                                    </label>
                                                  </li></>
                                                :
                                                item === "a4" ?
                                                  <><li
                                                    className=
                                                    {
                                                      (() => {
                                                        answerMatch4 = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                                        if (answerMatch4) {
                                                          const answer = answerMatch4[1]
                                                          if (answer == "ĐÚNG") {
                                                            return _.upperCase(question.ard) === 'ĐÚNG' ? 'true' : 'false'
                                                          }
                                                        }
                                                        return _.upperCase(question.ard) === 'ĐÚNG' ? 'true' : ""
                                                      })()
                                                    }
                                                  >
                                                    <input disabled id={`q_${question.id}a4`} defaultValue="A" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch4 ? (answerMatch4[1] === 'ĐÚNG' ? 'checked' : '') : ''} />
                                                    <label htmlFor={`q_${question.id}a4`} style={{ display: '-webkit-box' }} className="d-unset">
                                                      <strong>A.ĐÚNG</strong>
                                                    </label>
                                                  </li>
                                                    <li
                                                      className=
                                                      {
                                                        (() => {
                                                          answerMatch4 = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                                          if (answerMatch4) {
                                                            const answer = answerMatch4[1]
                                                            if (answer == "SAI") {
                                                              return _.upperCase(question.ard) === 'SAI' ? 'true' : 'false'
                                                            }
                                                          }
                                                          return _.upperCase(question.ard) === 'SAI' ? 'true' : ""
                                                        })()
                                                      }
                                                    >
                                                      <input disabled id={`q_${question.id}a4`} defaultValue="B" type="checkbox" name={`radioGroup_${question.id}`} defaultChecked={answerMatch4 ? (answerMatch4[1] === 'SAI' ? 'checked' : '') : ''} />
                                                      <label htmlFor={`q_${question.id}a4`} style={{ display: '-webkit-box' }} className="d-unset">
                                                        <strong>B.SAI</strong>
                                                      </label>
                                                    </li></>
                                                  : "không có đáp án"
                                        }

                                      </ul>
                                      <br></br>
                                      <div style={nump2==3 ? {display:''}:{display:'none'}}>
                                        <div className="btn-wrap mb-30">
                                          <a href="javascript:void(0);" id={"fullexplaintext_" + question.id + "_" + nump2} className="btn btn-secondary btn-ins" onClick={e => ShowHideFullExplain(e, question.id + "_" + nump2)}>Hướng dẫn giải</a>
                                        </div>
                                        <div className="block-text mb-30 fullexplain" id={"fullexplain_" + question.id + "_" + nump2}>
                                          <div className="text-inner overlay-scrollbar">
                                            {/* <MathJax math={question.full_explain.split('<p>&nbsp;</p>').join('')} /> */}
                                            <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.full_explain.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                ))}
                              </div>
                            }
                          </div>
                        );
                      }
                    } else if (thirdArray?.includes(question)) {
                      resetSTT2 += 1;
                      return (
                        <div className="qItem" id={`questionRegionItem_${question.id}`} style={num > 0 ? { display: 'none' } : { display: 'block' }}>
                          <h6>
                            <strong>Phần III.</strong>{showMessagePartTHPT(subjectId.current, 2, thirdArray.length)}
                          </h6>
                          <br></br>
                          <div className="question-header">
                            <h2><span style={{ fontWeight: 'bold', color: 'blue' }}>CÂU {resetSTT2} </span></h2>
                          </div>
                          {
                            question.content.replace(/<style[^>]*>.*<\/style>/gm, '').length > 2000
                              ?
                              <div className="question overlay-scrollbar" style={{ height: '210px' }}>
                                {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                              </div>
                              :
                              <div className="question overlay-scrollbar" style={{ height: 'auto', marginBottom: '40px' }}>
                                {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.content.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>

                              </div>
                          }
                          {/* <div className="answer" style={{ padding: "10px" }}>
                            <MathJax math={question.answerOfStudent.split('<p>&nbsp;</p>').join('')} />
                          </div> */}
                          <div className="answer" style={{ padding: "10px" }}>
                            {/* <input type="hidden" id={`hidden_${question.id}`} name={`hidden_${question.id}`} className="hiddenQIDCSS" data-id={question.id}
                              defaultValue={question.answerOfStudent} /> */}
                            {!question.isRight ?
                              <div >
                                <p>Câu trả lời</p>
                                <div style={{ padding: "10px", backgroundColor: "red", color: "white", borderRadius: "10px" }}>
                                  {/* <MathJax math={question.answerOfStudent.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(question.answerOfStudent.split('<p>&nbsp;</p>').join(''))}</MathJax></MathJaxContext>

                                </div>
                                <p>Đáp án</p>
                                <div style={{ marginTop: "4px", padding: "10px", backgroundColor: "white", color: "black", borderRadius: "10px" }}>
                                  {/* <MathJax math={question.ar.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(question.ar.split('<p>&nbsp;</p>').join(''))}</MathJax></MathJaxContext>

                                </div>
                              </div> : <div >
                                <p>Câu trả lời</p>
                                <div style={{ padding: "10px", backgroundColor: "green", color: "white", borderRadius: "10px" }}>
                                  {/* <MathJax math={question.answerOfStudent.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(question.answerOfStudent.split('<p>&nbsp;</p>').join(''))}</MathJax></MathJaxContext>

                                </div>
                                <p>Đáp án</p>
                                <div style={{ marginTop: "4px", padding: "10px", backgroundColor: "white", color: "black", borderRadius: "10px" }}>
                                  {/* <MathJax math={question.ar.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(question.ar.split('<p>&nbsp;</p>').join(''))}</MathJax></MathJaxContext>

                                </div>
                              </div>}
                          </div>
                          <br></br>
                          <div className="btn-wrap mb-30">
                            <a href="javascript:void(0);" id={"fullexplaintext_" + question.id} className="btn btn-secondary btn-ins" onClick={e => ShowHideFullExplain(e, question.id)}>Hướng dẫn giải</a>
                          </div>
                          <div className="block-text mb-30 fullexplain" id={"fullexplain_" + question.id}>
                            <div className="text-inner overlay-scrollbar">
                              {/* <MathJax math={question.full_explain.split('<p>&nbsp;</p>').join('')} /> */}
                              <MathJaxContext config={mathJaxConfig}><MathJax>{HtmlParse(config.convertAllMfencedInHtml(question.full_explain.split('<p>&nbsp;</p>').join('')))}</MathJax></MathJaxContext>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })
                }
              </div>
            }
          </div>

          <div className="block-question-info">
            <div className="info-inner">
              <ul className="info">
                <li><strong>{username}</strong></li>
                <li>{schoolname}</li>
                <li><strong>Phòng thi: {roomname}</strong></li>
              </ul>
              <div className="time-countdown" style={{ padding: "4px" }}>
                <h3>THỜI GIAN ĐÃ LÀM BÀI</h3>
                <ul id="countdown">
                  <li><span id="minutes">{getTime(parseInt(spendMunutes))}</span></li>
                  <li className="dots"><span>:</span></li>
                  <li><span id="seconds">{getTime(spendSeconds)}</span></li>
                </ul>
              </div>
              {/* Phần chọn câu hỏi để hiển thị môn toán*/}
              {/* Phần 1 */}
              <div className="questions-part1">
                <h3>Phần I</h3>
                <ul className="test-number">
                  {
                    firstArray?.map((question, num) => (
                      <li
                        className=
                        {
                          question.isAnswered == true
                            ? question.isRight == false
                              ? 'false btnq'
                              : 'true btnq'
                            : "btnq"
                        }
                        onClick={e => {
                          addClass(e, question.id)
                        }}
                        id={`q_btn_${question.id}`}
                        qid={question.id}
                        attrindex={num == 0 ? 1 : num + 1}
                      >
                        <a href={`${"#questionRegionItem_"+question.id}`}>
                          {`${num < 9 ? `0${num + 1}` : num + 1}`}
                        </a>
                      </li>
                    ))

                  }
                </ul>
              </div>
              {/* Phần 2 */}
              <div className="questions-part2">
                <div style={!_.isEmpty(secondArray) ? {display:''} : {display:'none'}} >
                  <h3>Phần II</h3>
                  {
                    secondArray?.map((question, num) => (
                      subjectId.current == 14 && isFree.current == false ?  // tin hoc
                      <>
                        {num==0 ?<h3>A/ Phần chung</h3>:""}
                        {
                          firstArraySubPart.includes(question) ? 
                          <>
                            <div className="question-item">
                              <span className="question-number">
                                <a href="javascript:void(0)" >
                                  {`${num < 5 ? `0${num + 1}` : num + 1}`}
                                </a>
                              </span>
                              <ul className="test-number">
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.ara) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a1")
                                  }}
                                  href={`${"#questionRegionItem_"+question.id}`}
                                  id={`q_btn_${question.id}a1`}
                                  qid={question.id}
                                  attrindex={1}><a href={`${"#questionRegionItem_"+question.id}`}>a</a></li>
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.arb) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a2")
                                  }}
                                  href={`${"#questionRegionItem_"+question.id}`}
                                  id={`q_btn_${question.id}a2`}
                                  qid={question.id}
                                  attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>b</a></li>
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.arc) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a3")
                                  }}
                                  href={`${"#questionRegionItem_"+question.id}`}
                                  id={`q_btn_${question.id}a3`}
                                  qid={question.id}
                                  attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>c</a></li>
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.ard) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a4")
                                  }}
                                  id={`q_btn_${question.id}a4`}
                                  qid={question.id}
                                  attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>d</a></li>
                              </ul>
                            </div>
                          </> :""
                        }
                        {
                          orientationType==1 && num == 2 ?
                            <div className='answer'>
                              <h3>B/ Phần riêng</h3>
                                <ul className='test-number-part2' style={{ cursor: "pointer"}}
                                  onClick={(e) => {
                                    addClassPart2(e, question.id, "a1")
                                  }}
                                >
                                  <ul qid={`${question.id}`}>
                                    <li  style={{ cursor:'auto' ,display:'-webkit-box', paddingLeft: '30px'}}>
                                      {/* <p>
                                        <input style={{ transform: 'scale(1.4)' }} disabled={1==1?true:false} checked={1==1?true:false} id={`tinhoc_${question.id}_1`} key={`q_${question.id}_1`} defaultValue="1" type="radio" name={`tinhocGroup`} />
                                      </p> */}
                                      <label htmlFor={`tinhoc_${question.id}_1`} style={{ paddingLeft:'10px' }}>
                                        <strong>Định hướng khoa học máy tính</strong>
                                      </label>
                                    </li>
                                  </ul>
                                </ul>
                            </div> :""
                        } 
                        {
                          orientationType==1 && secondArraySubPart.includes(question) ? 
                          <>
                            <div className="question-item">
                              <span className="question-number">
                                <a href="javascript:void(0)" >
                                  {`${num < 5 ? `0${num + 1}` : num + 1}`}
                                </a>
                              </span>
                              <ul className="test-number">
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.ara) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a1")
                                  }}
                                  href={`${"#questionRegionItem_"+question.id}`}
                                  id={`q_btn_${question.id}a1`}
                                  qid={question.id}
                                  attrindex={1}><a href={`${"#questionRegionItem_"+question.id}`}>a</a></li>
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.arb) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a2")
                                  }}
                                  href={`${"#questionRegionItem_"+question.id}`}
                                  id={`q_btn_${question.id}a2`}
                                  qid={question.id}
                                  attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>b</a></li>
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.arc) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a3")
                                  }}
                                  href={`${"#questionRegionItem_"+question.id}`}
                                  id={`q_btn_${question.id}a3`}
                                  qid={question.id}
                                  attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>c</a></li>
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.ard) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a4")
                                  }}
                                  id={`q_btn_${question.id}a4`}
                                  qid={question.id}
                                  attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>d</a></li>
                              </ul>
                            </div>
                          </> :""
                        }
                        {
                          orientationType==2 && num == 4 ?
                          <div className='answer'>
                            <h3>B/ Phần riêng</h3>
                              <ul className='test-number-part2' style={{ cursor: "pointer"}}
                              onClick={(e) => {
                                addClassPart2(e, question.id, "a1")
                              }}
                              >
                                <ul qid={`${question.id}`}>
                                  
                                  <li  style={{ cursor:'auto' ,display:'-webkit-box', paddingLeft: '30px'}}>
                                    {/* <p>
                                      <input style={{ transform: 'scale(1.4)' }} disabled={1==2?true:false} checked={1==2?true:false} id={`tinhoc_${question.id}_2`} key={`q_${question.id}_2`} defaultValue="2" type="radio" name={`tinhocGroup`} />
                                    </p> */}
                                    <label htmlFor={`tinhoc_${question.id}_2`} style={{ paddingLeft:'10px' }}>
                                      <strong>Định hướng Tin học ứng dụng</strong>
                                    </label>
                                  </li>
                                </ul>
                              </ul>
                          </div> :""
                        }
                        {
                          orientationType==2 && thirdArraySubPart.includes(question) ? 
                          <>
                            <div className="question-item">
                              <span className="question-number">
                                <a href="javascript:void(0)" >
                                  {`${num < 6 ? `0${num + 1}` : num + 1}`}
                                </a>
                              </span>
                              <ul className="test-number">
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.ara) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a1")
                                  }}
                                  href={`${"#questionRegionItem_"+question.id}`}
                                  id={`q_btn_${question.id}a1`}
                                  qid={question.id}
                                  attrindex={1}><a href={`${"#questionRegionItem_"+question.id}`}>a</a></li>
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.arb) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a2")
                                  }}
                                  href={`${"#questionRegionItem_"+question.id}`}
                                  id={`q_btn_${question.id}a2`}
                                  qid={question.id}
                                  attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>b</a></li>
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.arc) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a3")
                                  }}
                                  href={`${"#questionRegionItem_"+question.id}`}
                                  id={`q_btn_${question.id}a3`}
                                  qid={question.id}
                                  attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>c</a></li>
                                <li className=
                                  {
                                    (() => {
                                      const answerMatch = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                      if (answerMatch) {
                                        const answer = answerMatch[1]
                                        if (answer) {
                                          return _.upperCase(question.ard) === answer ? 'true btnq' : 'false btnq'
                                        }
                                      }
                                      return "btnq"
                                    })()
                                  }
                                  onClick={e => {
                                    addClassPart2(e, question.id, "a4")
                                  }}
                                  id={`q_btn_${question.id}a4`}
                                  qid={question.id}
                                  attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>d</a></li>
                              </ul>
                            </div>
                          </> :""
                        }
                      </> // end mon tin hoc
                      :
                      <>
                        <div className="question-item">
                          <span className="question-number">
                            <a href="javascript:void(0)" >
                              {`${num < 9 ? `0${num + 1}` : num + 1}`}
                            </a>
                          </span>
                          <ul className="test-number">
                            <li className=
                              {
                                (() => {
                                  const answerMatch = question.answerOfStudent.match(/a1(ĐÚNG|SAI)/)
                                  if (answerMatch) {
                                    const answer = answerMatch[1]
                                    if (answer) {
                                      return _.upperCase(question.ara) === answer ? 'true btnq' : 'false btnq'
                                    }
                                  }
                                  return "btnq"
                                })()
                              }
                              onClick={e => {
                                addClassPart2(e, question.id, "a1")
                              }}
                              href={`${"#questionRegionItem_"+question.id}`}
                              id={`q_btn_${question.id}a1`}
                              qid={question.id}
                              attrindex={1}><a href={`${"#questionRegionItem_"+question.id}`}>a</a></li>
                            <li className=
                              {
                                (() => {
                                  const answerMatch = question.answerOfStudent.match(/a2(ĐÚNG|SAI)/)
                                  if (answerMatch) {
                                    const answer = answerMatch[1]
                                    if (answer) {
                                      return _.upperCase(question.arb) === answer ? 'true btnq' : 'false btnq'
                                    }
                                  }
                                  return "btnq"
                                })()
                              }
                              onClick={e => {
                                addClassPart2(e, question.id, "a2")
                              }}
                              href={`${"#questionRegionItem_"+question.id}`}
                              id={`q_btn_${question.id}a2`}
                              qid={question.id}
                              attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>b</a></li>
                            <li className=
                              {
                                (() => {
                                  const answerMatch = question.answerOfStudent.match(/a3(ĐÚNG|SAI)/)
                                  if (answerMatch) {
                                    const answer = answerMatch[1]
                                    if (answer) {
                                      return _.upperCase(question.arc) === answer ? 'true btnq' : 'false btnq'
                                    }
                                  }
                                  return "btnq"
                                })()
                              }
                              onClick={e => {
                                addClassPart2(e, question.id, "a3")
                              }}
                              href={`${"#questionRegionItem_"+question.id}`}
                              id={`q_btn_${question.id}a3`}
                              qid={question.id}
                              attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>c</a></li>
                            <li className=
                              {
                                (() => {
                                  const answerMatch = question.answerOfStudent.match(/a4(ĐÚNG|SAI)/)
                                  if (answerMatch) {
                                    const answer = answerMatch[1]
                                    if (answer) {
                                      return _.upperCase(question.ard) === answer ? 'true btnq' : 'false btnq'
                                    }
                                  }
                                  return "btnq"
                                })()
                              }
                              onClick={e => {
                                addClassPart2(e, question.id, "a4")
                              }}
                              id={`q_btn_${question.id}a4`}
                              qid={question.id}
                              attrindex={num == 0 ? 1 : num + 1}><a href={`${"#questionRegionItem_"+question.id}`}>d</a></li>
                          </ul>
                        </div>
                      </>
                    ))
                  }
                </div>
              </div>
              {/* Phần 3 */}
              <div className="questions-part1">
                <div style={!_.isEmpty(thirdArray) ? {display:''} : {display:'none'}} >
                  <h3>Phần III</h3>
                  <ul className="test-number">
                    {thirdArray?.map((question, num) => (
                      <li
                        className=
                        {
                          question.isAnswered == true
                            ? question.isRight == false
                              ? 'false btnq'
                              : 'true btnq'
                            : "btnq"
                        }
                        onClick={e => {
                          addClass(e, question.id)
                        }}
                        id={`q_btn_${question.id}`}
                        qid={question.id}
                        attrindex={num == 0 ? 1 : num + 1}
                      >
                        <a href={`${"#questionRegionItem_"+question.id}`}>
                          {`${num < 6 ? `0${num + 1}` : num + 1}`}
                        </a>
                      </li>
                    ))}

                  </ul>
                </div>
              </div>
            </div>
            <div className="button-wrap">
              <a href={"/hanh-trinh-lam-bai?exam_record_id=" + examRecordIdCurrentURL.current+ "&question_type_id=" + questionTypeId.current} target="_blank" className="btn">Xem hành trình thi</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TeacherViewExam.propTypes = {
  history: PropTypes.object
};

export default withRouter(TeacherViewExam);
